import { useState } from "react";
import { IoClose } from "react-icons/io5";
import "./dedicatec.css";
const Dedicatedcontact = ({ message, phones = [] }) => {
  const [show, setShow] = useState(true);

  if (!show) return null;

  return (
    <div className="topNoticeBar">
      <div className="topNoticeBarMarquee">
        <div className="topNoticeBarContent">
          <span>{message}</span>

          {phones.map((phone, index) => (
            <span key={index}>
              {" "}
              <a href={`tel:${phone.replace(/[^\d]/g, "")}`}>{phone}</a>
              {index !== phones.length - 1 && ", "}
            </span>
          ))}
        </div>
      </div>

      <button className="topNoticeBarClose" onClick={() => setShow(false)}>
        <IoClose />
      </button>
    </div>
  );
};

export default Dedicatedcontact;
